import { useMediaQuery } from './useMediaQuery.ts';

export const useTabletAndDownQuery = () => useMediaQuery('(max-width: 768px)');
